
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const Terms = () => {
  const { language } = useLanguage();

  const sections = [
    {
      title: language === 'ar' ? 'قبول الشروط' : 'Acceptance of Terms',
      content: language === 'ar' 
        ? 'باستخدام منصة الإسكان الطلابي، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام خدماتنا.'
        : 'By using Student Housing platform, you agree to be bound by these terms and conditions. If you do not agree to these terms, please do not use our services.'
    },
    {
      title: language === 'ar' ? 'استخدام الخدمة' : 'Use of Service',
      content: language === 'ar'
        ? 'يجب استخدام خدماتنا فقط لأغراض قانونية ووفقاً لهذه الشروط. أنت مسؤول عن جميع الأنشطة التي تحدث تحت حسابك.'
        : 'You may use our services only for lawful purposes and in accordance with these terms. You are responsible for all activities that occur under your account.'
    },
    {
      title: language === 'ar' ? 'المحتوى المحظور' : 'Prohibited Content',
      content: language === 'ar'
        ? 'لا يُسمح بنشر محتوى غير قانوني أو ضار أو مسيء أو ينتهك حقوق الآخرين. نحتفظ بالحق في إزالة أي محتوى ينتهك هذه الشروط.'
        : 'You may not post content that is illegal, harmful, abusive, or violates the rights of others. We reserve the right to remove any content that violates these terms.'
    },
    {
      title: language === 'ar' ? 'المسؤولية' : 'Liability',
      content: language === 'ar'
        ? 'نحن نوفر المنصة "كما هي" ولا نضمن دقة أو اكتمال المعلومات المقدمة من المستخدمين. لن نكون مسؤولين عن أي أضرار قد تنتج عن استخدام خدماتنا.'
        : 'We provide the platform "as is" and do not guarantee the accuracy or completeness of information provided by users. We will not be liable for any damages that may result from using our services.'
    },
    {
      title: language === 'ar' ? 'إنهاء الخدمة' : 'Termination',
      content: language === 'ar'
        ? 'يمكننا إنهاء أو تعليق حسابك في أي وقت لأي سبب، بما في ذلك انتهاك هذه الشروط.'
        : 'We may terminate or suspend your account at any time for any reason, including violation of these terms.'
    }
  ];

  return (
    <div className={`min-h-screen ${language === 'ar' ? 'rtl' : 'ltr'}`}>
      <Header />
      
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Hero Section */}
          <div className="text-center mb-12">
            <Badge variant="secondary" className="mb-4">
              {language === 'ar' ? 'شروط الخدمة' : 'Terms of Service'}
            </Badge>
            <h1 className="text-4xl font-bold mb-6">
              {language === 'ar' ? 'شروط الخدمة' : 'Terms of Service'}
            </h1>
            <p className="text-muted-foreground">
              {language === 'ar' 
                ? 'آخر تحديث: ديسمبر 2024'
                : 'Last updated: December 2024'
              }
            </p>
          </div>

          {/* Introduction */}
          <Card className="mb-8">
            <CardContent className="p-8">
              <p className="text-lg">
                {language === 'ar'
                  ? 'مرحباً بك في منصة الإسكان الطلابي. هذه الشروط والأحكام تحكم استخدامك لخدماتنا. يرجى قراءتها بعناية.'
                  : 'Welcome to Student Housing platform. These terms and conditions govern your use of our services. Please read them carefully.'
                }
              </p>
            </CardContent>
          </Card>

          {/* Sections */}
          <div className="space-y-8">
            {sections.map((section, index) => (
              <Card key={index}>
                <CardContent className="p-8">
                  <h2 className="text-2xl font-bold mb-4">{section.title}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {section.content}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Contact Section */}
          <Card className="mt-12">
            <CardContent className="p-8 text-center">
              <h2 className="text-2xl font-bold mb-4">
                {language === 'ar' ? 'اتصل بنا' : 'Contact Us'}
              </h2>
              <p className="text-muted-foreground mb-4">
                {language === 'ar'
                  ? 'إذا كان لديك أي أسئلة حول هذه الشروط، يرجى الاتصال بنا:'
                  : 'If you have any questions about these terms, please contact us:'
                }
              </p>
              <p className="font-medium">support@studenthousing.eg</p>
            </CardContent>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
